<template>
  <div class="d-flex align-items-center">
    <em class="fas fa-globe font-18 color-primary-4 mr-2" />
    <custom-drop-action
      v-model="selected"
      :options="options"
      @input="onChangeHandler"
    />
  </div>
</template>

<script>
//components
import { CustomDropAction } from '@/components/common';

export default {
  name: 'LanguageSelector',
  components: {
    CustomDropAction,
  },
  data: () => ({
    selected: {
      id: 1,
      name: 'Spanish',
    },
  }),
  computed: {
    options() {
      return [
        {
          id: 1,
          name: 'Spanish',
        },
        {
          id: 2,
          name: 'English',
        },
      ];
    },
  },
  methods: {
    onChangeHandler() {},
  },
};
</script>
